import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from '../../Checkbox';

const FormCheckbox = ({ input, ...props }) => (<Checkbox
    checked={input.value === true}
    {...input}
    {...props}
/>);

FormCheckbox.propTypes = {
    input: PropTypes.object,
};

export default FormCheckbox;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/FormCheckbox/FormCheckbox.js